module.exports = __webpack_public_path__ + "static/img/produto_p.29ff826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina-zero/produto_p.png
// module id = RuQp
// module chunks = 0